import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { WhatsAppFloatingButton } from './components/base/WhatsAppFloatingButton'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppFloatingButton />
    </BrowserRouter>
  )
}

export default App
